import React from 'react';
import { Box } from '@tanium/react-box';

export interface Props {
  children?: React.ReactNode;
}

export const FormSectionBody = ({ children }: Props) => (
  <Box p={2} display="flex" flexDirection="column">
    {children}
  </Box>
);
